module.exports = __webpack_public_path__ + "img/shkendija.fef0a399.png";